var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import CurrencyFormatter from '../../../core/utils/currency-formatter';
import CartItemTitle from './CartItemTitle';
import CartItemImage from '../../../components/CartItemImage';
import CartItemPhotoList from './CartItemPhotoList';
import { createClassListFromModifiers } from '../../../core/utils/class-helper';
import CtaButton from '../../../components/CtaButton';
import { localizeUrl } from '../../../core/helpers/url-helper';
import CartListItemMultiplier from './CartListItemMultiplier';
import CartListItemActionDecrease from './CartListItemActionDecrease';
import CartItemAddonList from './CartItemAddonList';
var CartListItem = /** @class */ (function (_super) {
    __extends(CartListItem, _super);
    function CartListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    CartListItem.prototype.render = function () {
        var _this = this;
        var classList = __spreadArray([
            'c-cart-list-item'
        ], createClassListFromModifiers('c-cart-list-item', this.props.modifier));
        return (React.createElement("div", { className: classList.join(' ') },
            React.createElement("div", { className: "c-cart-list-item__content" },
                React.createElement("div", { className: "c-cart-list-item__content__image" },
                    React.createElement(CartItemImage, { item: this.props.item })),
                React.createElement("div", { className: "c-cart-list-item__content__right" },
                    React.createElement("div", { className: "c-cart-list-item__content__right__name" },
                        React.createElement(CartItemTitle, { item: this.props.item })),
                    React.createElement("div", { className: "c-cart-list-item__content__right__price" },
                        React.createElement("span", null, CurrencyFormatter.format(this.props.item.getTotal()))),
                    React.createElement("div", { className: "c-cart-list-item__content__right__bottom" },
                        React.createElement("div", { className: "c-cart-list-item__content__right__bottom__multiplier" },
                            !!this.props.item.product.is_multipliable && React.createElement(CartListItemMultiplier, { item: this.props.item }),
                            !this.props.item.product.is_multipliable && React.createElement(CartListItemActionDecrease, { item: this.props.item, icon: "remove" })),
                        React.createElement("div", { className: "c-cart-list-item__content__right__bottom__toggler" },
                            React.createElement("i", { className: "h-cursor--pointer icon-" + (this.state.isOpen ? 'up' : 'down'), onClick: function () { return _this.setState({ isOpen: !_this.state.isOpen }); } }))))),
            this.state.isOpen && (React.createElement("div", { className: "c-cart-list-item__bottom" },
                this.props.item.addons && React.createElement(CartItemAddonList, { items: this.props.item.addons }),
                React.createElement(CartItemPhotoList, { item: this.props.item }),
                React.createElement("div", { className: "h-padding-top--15 h-padding-top--md-30" },
                    React.createElement(CtaButton, { link: localizeUrl("/cart-items/" + this.props.item.id), icon: "add", label: "button.edit_order", modifier: ['pink-100', 'icon-right', 'wide', 'xs-full'] }))))));
    };
    return CartListItem;
}(React.Component));
export default withTranslation()(CartListItem);
